import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function adaptation1AdaptFacetValue(facetValue) {
  var additionalFacetValueFieldsForField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var count = facetValue.count,
      value = facetValue.value,
      rest = _objectWithoutProperties(facetValue, ["count", "value"]);

  return {
    count: count,
    value: value ? value : _objectSpread({}, rest, {}, additionalFacetValueFieldsForField)
  };
}

function adaptation2AddLabelToFacet(fieldName, facet) {
  return _objectSpread({
    field: fieldName
  }, facet);
}

function adaptFacets(facets, _ref) {
  var _ref$additionalFacetV = _ref.additionalFacetValueFields,
      additionalFacetValueFields = _ref$additionalFacetV === void 0 ? {} : _ref$additionalFacetV;
  if (!facets || Object.keys(facets).length === 0) return facets;
  return Object.entries(facets).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        fieldName = _ref3[0],
        facet = _ref3[1];

    var adaptedFacet = facet.map(function (v) {
      var type = v.type,
          data = v.data,
          rest = _objectWithoutProperties(v, ["type", "data"]);

      return adaptation2AddLabelToFacet(fieldName, _objectSpread({
        type: type,
        data: data.map(function (f) {
          return adaptation1AdaptFacetValue(f, additionalFacetValueFields[fieldName]);
        })
      }, rest));
    });
    return _objectSpread({}, acc, _defineProperty({}, fieldName, adaptedFacet));
  }, {});
}

export function adaptResponse(response) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var facets = response.info.facets;
  var requestId = response.info.meta.request_id;
  var totalPages = response.info.meta.page ? response.info.meta.page.total_pages : undefined;
  var totalResults = response.info.meta.page ? response.info.meta.page.total_results : undefined;
  return _objectSpread({}, facets && {
    facets: adaptFacets(facets, options)
  }, {
    requestId: requestId,
    results: response.rawResults
  }, totalPages !== undefined && {
    totalPages: totalPages
  }, {}, totalResults !== undefined && {
    totalResults: totalResults
  });
}